import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/utils/index-of';
import __var_2__ from './orientations.json';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var indexOf = __var_1__;
var ORIENTATIONS = __var_2__;


// VARIABLES //

var debug = logger( 'rug:set:orientation' );


// MAIN //

/**
* Sets the orientation.
*
* @private
* @param {string} orient - orientation
* @throws {TypeError} must be a supported orientation
*/
function set( orient ) {
	/* eslint-disable no-invalid-this */
	if ( indexOf( ORIENTATIONS, orient ) === -1 ) {
		throw new Error( 'invalid value. `orientation` must be one of `['+ORIENTATIONS.join(',')+']`. Value: `' + orient + '.`' );
	}
	if ( orient !== this._orientation ) {
		debug( 'Current value: %d.', this._orientation );

		this._orientation = orient;
		debug( 'New Value: %d.', this._orientation );

		this.emit( 'change' );
	}
}


// EXPORTS //
export default set;
